//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ClosedType from './cpts/closed'
import InactiveType from './cpts/inactive-type'
export default {
  components: {
    ClosedType,
    InactiveType
  },
  props: {
    type: {
      type: String,
      default: 'frozen' // or 'investigate' - '調查中'
    },
    times: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showModel () {
      return !['/carbonAccount/purchase', '/carbonAccount/trail'].includes(this.$route.path)
    }
  }
}
